import React from "react";
import { Controller } from "react-hook-form";
import { Form } from "@ant-design/compatible";
import { Row, Col } from "antd";

import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import { Input, Select } from "../../Common/Input";
import PMSSelect from "../PMSSelect/PMSSelect";
import { TimezoneList } from "../../../utils/common-utils";
import "./styles.css";

const Timezones = TimezoneList.map((time) => {
  return {
    value: time,
    label: time,
  };
});

const PropertyDetailsForm = (props) => {
  const { errors, control, disableStatus } = props;

  return (
    <Row style={{ width: "100%" }}>
      <Col span={16} offset={4}>
        <Form layout="vertical" className="onboarding-form">
          <Row>
            <Col span={12}>
              <Row>
                <Form.Item
                  label={<RequiredFormLabel value="Property Name" />}
                  help={errors?.property_name?.message}
                  validateStatus={errors?.property_name ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="property_name"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={disableStatus}
                      />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label={<RequiredFormLabel value="Property Code" />}
                  help={errors?.property_code?.message}
                  validateStatus={errors?.property_code ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="property_code"
                    render={({ field: { onChange, value } }) => (
                      <Input
                        value={value}
                        onChange={onChange}
                        disabled={disableStatus}
                      />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item label="Property Brand" help={errors?.brand?.message}>
                  <Controller
                    control={control}
                    name="brand"
                    render={({ field: { onChange, value } }) => (
                      <Input value={value} onChange={onChange} />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label={<RequiredFormLabel value="PMS" />}
                  help={errors?.pms?.message}
                  validateStatus={errors?.pms ? "error" : ""}
                >
                  <Controller
                    control={control}
                    name="pms"
                    render={({ field: { onChange, value } }) => (
                      <PMSSelect onChange={onChange} value={value} />
                    )}
                  />
                </Form.Item>
              </Row>
            </Col>

            <Col span={12}>
              <Row>
                <Form.Item
                  label="Time Zone"
                  help={errors?.property_time_zone?.message}
                >
                  <Controller
                    control={control}
                    name="property_time_zone"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={onChange}
                        placeholder="Time Zone"
                        options={Timezones}
                      />
                    )}
                  ></Controller>
                </Form.Item>
              </Row>

              <Row>
                <Form.Item label="POS" help={errors?.pos?.message}>
                  <Controller
                    control={control}
                    name="pos"
                    render={({ field: { onChange, value } }) => (
                      <Input value={value} onChange={onChange} />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label={
                    <RequiredFormLabel value="Property Contact First Name" />
                  }
                  help={errors?.property_contact?.first_name?.message}
                  validateStatus={
                    errors?.property_contact?.first_name ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="property_contact.first_name"
                    render={({ field: { onChange, value } }) => (
                      <Input value={value} onChange={onChange} />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label={
                    <RequiredFormLabel value="Property Contact Last Name" />
                  }
                  help={errors?.property_contact?.last_name?.message}
                  validateStatus={
                    errors?.property_contact?.last_name ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="property_contact.last_name"
                    render={({ field: { onChange, value } }) => (
                      <Input value={value} onChange={onChange} />
                    )}
                  />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label={<RequiredFormLabel value="Property Contact Email" />}
                  help={errors?.property_contact?.email?.message}
                  validateStatus={
                    errors?.property_contact?.email ? "error" : ""
                  }
                >
                  <Controller
                    control={control}
                    name="property_contact.email"
                    render={({ field: { onChange, value } }) => (
                      <Input value={value} onChange={onChange} disabled />
                    )}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default PropertyDetailsForm;
